import axios from 'axios';
import _isEmpty from 'lodash/isEmpty';
import Page from '../../../js/lib/page';
import { getUrlWithQueryParams } from '../../helpers/globalHelper';

// Constants
export const PERSONALIZED_FEED_REQUESTED = 'PERSONALIZED_FEED_REQUESTED';
export const PERSONALIZED_FEED_SUCCESS = 'PERSONALIZED_FEED_SUCCESS';
export const PERSONALIZED_FEED_ERROR = 'PERSONALIZED_FEED_ERROR';

export const PERSONALIZED_FEED_API_URL = '/smarthelp/api/get-personalized-feed';

// Actions
const requestPersonalizedFeed = () => ({ type: PERSONALIZED_FEED_REQUESTED });

const receivedPersonalizedFeedError = (e) => ({ type: PERSONALIZED_FEED_ERROR, payload: e });

const receivedPersonalizedFeed = (pfData) => {
  const ocp = pfData.ocp || {};
  const refunds = pfData.refunds || {};
  const disputes = pfData.disputes || [];
  const recommendedSolutions = pfData.recommendedSolutions || {};
  const isOCPEnabled = !_isEmpty(ocp) && Array.isArray(ocp.intentDetails) && ocp.intentDetails.length > 0;
  const isRefundsAvailable = !_isEmpty(refunds) && Array.isArray(refunds.items) && refunds.items.length > 0;
  const isDisputeAvailable = Array.isArray(disputes) && disputes.length > 0;
  const isPersonalizedDataAvailable = isOCPEnabled || isRefundsAvailable || isDisputeAvailable;
  return {
    payload: {
      ocp,
      recommendedSolutions,
      refunds,
      disputes,
      isPersonalizedDataAvailable,
      isOCPEnabled,
      isRefundsAvailable,
      isDisputeAvailable,
    },
    type: PERSONALIZED_FEED_SUCCESS,
  };
};

// fetch personalized info - OCP -NNA- Refund trackers
export const getPersonalizedFeed = () => (dispatch) => {
  dispatch(requestPersonalizedFeed());
  const personalizedFeedUrl = `${getUrlWithQueryParams(PERSONALIZED_FEED_API_URL, {
    pathName: 'home',
    ocp: true,
    trackers: true,
  })}`;
  return axios
    .get(Page.setChannelForTechnicalExp(personalizedFeedUrl))
    .then((feedResponse) => {
      dispatch(receivedPersonalizedFeed(feedResponse.data));
    })
    .catch((e) => dispatch(receivedPersonalizedFeedError(e)));
};
